<template lang="pug">
div(class='City', v-if='contacts')
	UiSelect(
		placeholder='Выбор города',
		v-model='contactsCurrentId',
		:items='contactsSelectList',
		iconLeft='system/map',
		iconLeftSize='md',
		variant='secondary',
		:theme='lessThan("desktopMedium") ? "ghost" : "ghost"',
		:size='lessThan("mobileMedium") ? "xs" : lessThan("desktopWide") ? "sm" : "md"',
		padded,
		rounded
	)
</template>

<script lang="ts" setup>
const { fetchContacts, contactsCurrentId, contactsSelectList, contacts } = useContacts();
const { lessThan } = usePlatform();

await fetchContacts();
</script>

<style lang="less" scoped>
.Contacts {
	.box(grid; auto; auto; none; 1rem; 1fr; auto auto; center; center; column);
	& > .Address {
		.text(@ColorBase; 0.875rem 0.75rem @medium);

		@media all and (min-width: @mobile-small) {
			.text(@ColorBase; 1rem 0.875rem @medium);
		}
	}
}
</style>
